export class JSONUtil {

    static copyByValue(object:any){
        return JSON.parse(JSON.stringify(object));
    }

}